"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutableFeedConfiguration = exports.FeedConfiguration = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var abstract_struct_1 = require("../abstract-struct");
var with_default_value_1 = require("../../class-transformers/with-default-value");
var case_insensitive_ingest_1 = require("../../class-transformers/case-insensitive-ingest");
var enums_1 = require("../../enums");
var relative_date_1 = require("../relative-date");
var abstract_feed_schedule_1 = require("./abstract-feed-schedule");
var fixed_feed_schedule_1 = require("./fixed-feed-schedule");
var asap_feed_schedule_1 = require("./asap-feed-schedule");
var stz_feed_schedule_1 = require("./stz-feed-schedule");
var feed_path_1 = require("./feed-path");
var ScheduleTypeMap = (_a = {},
    _a[enums_1.FeedSendStrategy.FIXED] = fixed_feed_schedule_1.FixedFeedSchedule,
    _a[enums_1.FeedSendStrategy.ASAP] = asap_feed_schedule_1.AsapFeedSchedule,
    _a[enums_1.FeedSendStrategy.SUBSCRIBER_TIME_ZONE] = stz_feed_schedule_1.StzFeedSchedule,
    _a);
var extractPossibleSendStrategy = function (value) {
    var _a;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
        return ((_a = value.sendStrategy) !== null && _a !== void 0 ? _a : value.send_strategy);
    }
};
var FeedConfiguration = (function (_super) {
    __extends(FeedConfiguration, _super);
    function FeedConfiguration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Transform)(function (_a) {
            var value = _a.value, obj = _a.obj;
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                var sendStrategy = extractPossibleSendStrategy(value);
                if (sendStrategy) {
                    var mappedType = ScheduleTypeMap[sendStrategy];
                    if (mappedType) {
                        value = value instanceof mappedType
                            ? value.clone()
                            : mappedType.parseJsonObject(value);
                    }
                }
            }
            return value;
        }, { toClassOnly: true }),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function (opts) {
            var _a;
            var sendStrategy = extractPossibleSendStrategy((_a = opts === null || opts === void 0 ? void 0 : opts.object) === null || _a === void 0 ? void 0 : _a.schedule);
            var valueType;
            if (sendStrategy) {
                valueType = ScheduleTypeMap[sendStrategy];
            }
            valueType !== null && valueType !== void 0 ? valueType : (valueType = abstract_feed_schedule_1.AbstractFeedSchedule);
            return valueType;
        }),
        __metadata("design:type", Object)
    ], FeedConfiguration.prototype, "schedule", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'field_options' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        __metadata("design:type", Object)
    ], FeedConfiguration.prototype, "fieldOptions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'required_keywords' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Array)
    ], FeedConfiguration.prototype, "requiredKeywords", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'restricted_keywords' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Array)
    ], FeedConfiguration.prototype, "restrictedKeywords", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'url_allowlist' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Array)
    ], FeedConfiguration.prototype, "urlAllowlist", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'url_denylist' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Array)
    ], FeedConfiguration.prototype, "urlDenylist", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'title_denylist' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Array)
    ], FeedConfiguration.prototype, "titleDenylist", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'article_recycling' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(false),
        (0, class_validator_1.IsBoolean)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Boolean)
    ], FeedConfiguration.prototype, "articleRecycling", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'article_max_age' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return relative_date_1.RelativeDate; }),
        (0, class_validator_1.IsObject)(),
        __metadata("design:type", relative_date_1.RelativeDate)
    ], FeedConfiguration.prototype, "articleMaxAge", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'notification_lifespan' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return relative_date_1.RelativeDate; }),
        (0, class_validator_1.IsObject)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], FeedConfiguration.prototype, "notificationLifespan", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'channels' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Array)
    ], FeedConfiguration.prototype, "channels", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'feed_jsonpath' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return feed_path_1.FeedPath; }),
        (0, class_validator_1.IsObject)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", feed_path_1.FeedPath)
    ], FeedConfiguration.prototype, "feedJsonpath", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'feed_xpath' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return feed_path_1.FeedPath; }),
        (0, class_validator_1.IsObject)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", feed_path_1.FeedPath)
    ], FeedConfiguration.prototype, "feedXpath", void 0);
    return FeedConfiguration;
}(abstract_struct_1.AbstractStruct));
exports.FeedConfiguration = FeedConfiguration;
exports.MutableFeedConfiguration = FeedConfiguration;
//# sourceMappingURL=feed-configuration.js.map